import { AbstractComponent } from "appworks/components/abstract-component";
import { Layers } from "appworks/graphics/layers/layers";
import { Text } from "appworks/graphics/pixi/text";
import { CurrencyService } from "appworks/services/currency/currency-service";
import { Services } from "appworks/services/services";
import { gameiomModel, JackpotTiers } from "gameiom/model/gameiom-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsJackpotDisplayComponent extends AbstractComponent {
    protected textInstances: Map<JackpotTiers, Text> = null;
    protected layer: Layers;

    public init() {
        this.layer = Layers.get("Jackpots");
        this.updateValues();
        Services.get(SlotBetService).onBetChange.add(() => this.updateValues());
    }

    public updateValues(): void {
        this.updateTextInstances();
        this.textInstances.forEach((text, jackpotTier) => {
            if (text) {
                text.text = this.getJackpotValue(jackpotTier);
            }
        });
    }

    public getJackpotAmount(tier: JackpotTiers): number {
        if (!gameiomModel.jackpotAmounts) { return; }
        const creditSize: number = Services.get(SlotBetService).getCreditSize();
        return gameiomModel.jackpotAmounts.get(tier) * creditSize;
    }

    public getJackpotValue(tier: JackpotTiers): string {
        if (!gameiomModel.jackpotAmounts) { return; }
        return Services.get(CurrencyService).format(this.getJackpotAmount(tier), false, false);
    }

    protected updateTextInstances() {
        this.textInstances = new Map<JackpotTiers, Text>([
            [JackpotTiers.MINI, this.layer.getText("mini_value")],
            [JackpotTiers.MINOR, this.layer.getText("minor_value")],
            [JackpotTiers.MAJOR, this.layer.getText("major_value")],
            [JackpotTiers.GRAND, this.layer.getText("grand_value")]
        ]);
    }
}
